import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../hooks/useToast';
import api from '../services/api';

const تسجيلالدخول = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  const { showToast, ToastContainer } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      showToast('يرجى إدخال البريد الإلكتروني وكلمة المرور', 'error');
      return;
    }

    setLoading(true);
    try {
      const result = await login({ email, password });
      if (result.success) {
        showToast('تم تسجيل الدخول بنجاح', 'success');
        // Redirect will happen automatically via AuthContext
        setTimeout(() => {
          window.location.reload();
        }, 500);
      } else {
        showToast(result.message || 'فشل تسجيل الدخول - تأكد من صحة البيانات', 'error');
      }
    } catch (error) {
      showToast('حدث خطأ أثناء تسجيل الدخول - تأكد من أن الباك اند يعمل', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      width: '100vw',
      height: '100vh',
      background: 'linear-gradient(135deg, #2B2F3F 0%, #1a1d2a 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      direction: 'rtl',
      position: 'relative',
      overflow: 'hidden',
      padding: '40px 20px'
    }}>
      {/* Background decorative elements */}
      <div style={{
        position: 'absolute',
        top: '-50%',
        right: '-20%',
        width: '600px',
        height: '600px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, rgba(233, 106, 58, 0.1) 0%, rgba(233, 106, 58, 0.05) 100%)',
        filter: 'blur(80px)',
        zIndex: 0
      }}></div>
      <div style={{
        position: 'absolute',
        bottom: '-30%',
        left: '-10%',
        width: '500px',
        height: '500px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, rgba(242, 125, 114, 0.1) 0%, rgba(242, 125, 114, 0.05) 100%)',
        filter: 'blur(80px)',
        zIndex: 0
      }}></div>

      {/* Logo - Above the card */}
      <div style={{
        textAlign: 'center',
        marginBottom: '32px',
        animation: 'fadeIn 0.8s ease-out',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{
          width: '160px',
          height: '160px',
          margin: '0 auto 24px',
          borderRadius: '24px',
          background: '#FFFFFF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0px 12px 32px rgba(0, 0, 0, 0.15), 0px 0px 0px 1px rgba(233, 106, 58, 0.1)',
          position: 'relative',
          overflow: 'hidden',
          padding: '20px'
        }}>
          <img 
            src="/Group 1000019470.png" 
            alt="Logo" 
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'contain',
              position: 'relative',
              zIndex: 1
            }}
          />
        </div>
        <h1 style={{
          fontFamily: 'El Messiri, sans-serif',
          fontSize: '38px',
          fontWeight: 700,
          color: '#FFFFFF',
          margin: '0 0 12px 0',
          textShadow: '0px 2px 8px rgba(0, 0, 0, 0.2)',
          letterSpacing: '-0.5px'
        }}>
          مرحباً بك
        </h1>
        <p style={{
          fontFamily: 'Cairo, sans-serif',
          fontSize: '17px',
          color: 'rgba(255, 255, 255, 0.9)',
          margin: 0,
          fontWeight: 500,
          lineHeight: '1.6',
          textShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)'
        }}>
          أدخل بياناتك للوصول إلى لوحة التحكم
        </p>
      </div>

      <div style={{
        backgroundColor: '#FFFFFF',
        borderRadius: '32px',
        padding: '48px 40px',
        width: '100%',
        maxWidth: '480px',
        boxShadow: '0px 20px 60px rgba(0, 0, 0, 0.3), 0px 0px 0px 1px rgba(233, 106, 58, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        position: 'relative',
        zIndex: 1,
        animation: 'fadeInUp 0.6s ease-out'
      }}>

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ animation: 'fadeIn 1s ease-out' }}>
          <div style={{ marginBottom: '24px' }}>
            <label style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontFamily: 'Cairo, sans-serif',
              fontSize: '14px',
              fontWeight: 600,
              color: '#2B2F3F',
              marginBottom: '10px'
            }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#666A7A" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              البريد الإلكتروني
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="example@email.com"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '16px 16px 16px 48px',
                  borderRadius: '14px',
                  border: '2px solid rgba(102, 106, 122, 0.15)',
                  fontFamily: 'Cairo, sans-serif',
                  fontSize: '15px',
                  outline: 'none',
                  boxSizing: 'border-box',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  backgroundColor: loading ? '#f9f9f9' : '#FFFFFF',
                  color: '#2B2F3F'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#E96A3A';
                  e.target.style.boxShadow = '0px 0px 0px 4px rgba(233, 106, 58, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'rgba(102, 106, 122, 0.15)';
                  e.target.style.boxShadow = 'none';
                }}
                dir="ltr"
              />
              <div style={{
                position: 'absolute',
                right: '16px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#666A7A',
                pointerEvents: 'none'
              }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <label style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontFamily: 'Cairo, sans-serif',
              fontSize: '14px',
              fontWeight: 600,
              color: '#2B2F3F',
              marginBottom: '10px'
            }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#666A7A" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              كلمة المرور
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '16px 48px 16px 16px',
                  borderRadius: '14px',
                  border: '2px solid rgba(102, 106, 122, 0.15)',
                  fontFamily: 'Cairo, sans-serif',
                  fontSize: '15px',
                  outline: 'none',
                  boxSizing: 'border-box',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  backgroundColor: loading ? '#f9f9f9' : '#FFFFFF',
                  color: '#2B2F3F',
                  letterSpacing: showPassword ? '0' : '4px'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#E96A3A';
                  e.target.style.boxShadow = '0px 0px 0px 4px rgba(233, 106, 58, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'rgba(102, 106, 122, 0.15)';
                  e.target.style.boxShadow = 'none';
                }}
                dir="ltr"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                disabled={loading}
                style={{
                  position: 'absolute',
                  left: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  padding: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#666A7A',
                  transition: 'color 0.2s',
                  opacity: loading ? 0.5 : 1
                }}
                onMouseEnter={(e) => {
                  if (!loading) e.target.style.color = '#E96A3A';
                }}
                onMouseLeave={(e) => {
                  if (!loading) e.target.style.color = '#666A7A';
                }}
              >
                {showPassword ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading || !email || !password}
            style={{
              width: '100%',
              padding: '18px',
              borderRadius: '14px',
              border: 'none',
              background: loading || !email || !password 
                ? 'linear-gradient(135deg, #cccccc 0%, #aaaaaa 100%)' 
                : 'linear-gradient(135deg, #E96A3A 0%, #F27D72 100%)',
              color: '#FFFFFF',
              fontFamily: 'El Messiri, sans-serif',
              fontSize: '17px',
              fontWeight: 600,
              cursor: (loading || !email || !password) ? 'not-allowed' : 'pointer',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              boxShadow: (loading || !email || !password) 
                ? 'none' 
                : '0px 8px 24px rgba(233, 106, 58, 0.4)',
              position: 'relative',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px',
              letterSpacing: '0.3px'
            }}
            onMouseEnter={(e) => {
              if (!loading && email && password) {
                e.target.style.transform = 'translateY(-2px) scale(1.01)';
                e.target.style.boxShadow = '0px 12px 32px rgba(233, 106, 58, 0.5)';
              }
            }}
            onMouseLeave={(e) => {
              if (!loading && email && password) {
                e.target.style.transform = 'translateY(0) scale(1)';
                e.target.style.boxShadow = '0px 8px 24px rgba(233, 106, 58, 0.4)';
              }
            }}
          >
            {loading ? (
              <>
                <div style={{
                  width: '22px',
                  height: '22px',
                  border: '3px solid rgba(255, 255, 255, 0.3)',
                  borderTop: '3px solid #FFFFFF',
                  borderRadius: '50%',
                  animation: 'spin 0.8s linear infinite'
                }}></div>
                <span>جاري تسجيل الدخول...</span>
              </>
            ) : (
              <>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                  <polyline points="10 17 15 12 10 7"/>
                  <line x1="15" y1="12" x2="3" y2="12"/>
                </svg>
                <span>تسجيل الدخول</span>
              </>
            )}
          </button>
        </form>

        {/* Footer */}
        <div style={{
          marginTop: '36px',
          paddingTop: '28px',
          borderTop: '1px solid rgba(102, 106, 122, 0.1)',
          textAlign: 'center'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            marginBottom: '8px'
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
            <p style={{
              fontFamily: 'Cairo, sans-serif',
              fontSize: '13px',
              color: '#999',
              margin: 0,
              fontWeight: 500
            }}>
              محمي بأمان عالي
            </p>
          </div>
          <p style={{
            fontFamily: 'Cairo, sans-serif',
            fontSize: '12px',
            color: '#bbb',
            margin: 0
          }}>
            © 2025 Min Bayty. جميع الحقوق محفوظة
          </p>
        </div>
      </div>
      <ToastContainer />
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes shimmer {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.7;
          }
        }
        input:focus {
          border-color: #E96A3A !important;
          box-shadow: 0px 0px 0px 4px rgba(233, 106, 58, 0.1) !important;
        }
      `}</style>
    </div>
  );
};

export default تسجيلالدخول;
